import { all } from 'redux-saga/effects'
import imageSaga from './image.saga'
import settingsSaga from './settings.saga'

function* rootSaga() {
  try {
    yield all([...imageSaga])
    yield all([...settingsSaga])
  } catch (e) {
    console.error(e)
    throw e
  }
}

export default rootSaga
